// extracted by mini-css-extract-plugin
export var expandIcon = "fC_vW";
export var rotated = "fC_vX";